module.exports = __webpack_public_path__ + "img/banner5.5558d618.jpg";